import React, { useEffect, useState, useRef, useMemo } from "react";
import styled from "styled-components";
import i18n from 'i18next';
import { useTranslation } from "react-i18next";
import { Form, useParams } from "react-router-dom";
import { Select, DatePicker, ConfigProvider } from 'antd';
import { Alert } from "iron-man";

import dayjs from 'dayjs';
import debounce from 'lodash/debounce';

import Flex from "../../core/Flex";
import FormHeader from "../../form/FormHeader";
import FormTitle from "../../form/FormTitle";
import FormSelect from "../../form/FormSelect";
import FormField from "../../form/FormField";
import FormLabel from "../../form/FormLabel";
import FormText from "../../form/FormText";
import FormInput from "../../form/FormInput";
import FormTextarea from "../../form/FormTextarea";
import FormRadioButton from "../../form/FormRadioButton";
import FormCheckbox from "../../form/FormCheckbox";
import FormRemark from "../../form/FormRemark";
import FormInputError from "../../form/FormInputError";
import ShadowBox from "../../core/ShadowBox";
import Space from "../../core/Space";
import useAuthAdminStore from "../../../store/useAuthAdminStore";
import useAdminApplicationDetailStore from "../../../store/useAdminApplicationDetailStore";
import useModalStore from "../../../store/useModalStore";
import withErrorHandling from "../../../function/withErrorHandling";
import withErrorHandlingForAll from "../../../function/withErrorHandlingForAll";
import { ContentComposeEmail } from "./Email";
import formatCurrency from "../../../function/formatCurrency";
import { isProduction } from "@/setting";

export const ContentScheduledChargeback = () => {
  const { contentScheduledChargeback_Chargeback_datatime, setContentScheduledChargeback_Chargeback_datatime, setIsValid_contentScheduledChargeback_Chargeback_datatime, isValid_contentScheduledChargeback_Chargeback_datatime } = useAdminApplicationDetailStore();
  const { data } = useAdminApplicationDetailStore();

  return (
    <Flex gap={24} direction={"column"} alignItems={"flex-start"}>
      <FormText>Charge the following amount from the authorized credit card</FormText>

      <Flex direction={"column"} alignItems={"flex-start"} gap={8} width={"100%"}>
        <Flex justifyContent={"space-between"} alignItems={"flex-start"} gap={8} width={"100%"}>
          <FormField style={{ flex: 1, marginBottom: 0 }}>
            <FormLabel htmlFor="chargeback">Chargeback</FormLabel>
            <FormInput id="chargeback" prefix={"HK$"} disabled={true} value={data?.claim?.chargeBack ?? "0"} placeholder="0" aria-label="Chargeback" />
          </FormField>
        </Flex>
        <Flex justifyContent={"space-between"} alignItems={"flex-start"} gap={8} width={"100%"}>
          <FormField style={{ flex: 1, marginBottom: 0 }}>
            <FormLabel htmlFor="chargeback_datetime">Chargeback Date & Time</FormLabel>
            <DatePicker
              id="chargeback_datetime"
              maxDate={dayjs().add(3, "month")}
              placeholder={"Select Date & Time"}
              value={contentScheduledChargeback_Chargeback_datatime ? dayjs(contentScheduledChargeback_Chargeback_datatime) : null}
              size={"large"}
              showTime
              style={{ width: "100%" }}
              onChange={(date, dateString) => {
                setContentScheduledChargeback_Chargeback_datatime(dateString);
                setIsValid_contentScheduledChargeback_Chargeback_datatime(true);
              }}
              aria-label="Chargeback Date & Time"
            />
            <FormInputError show={!isValid_contentScheduledChargeback_Chargeback_datatime}>* Please enter Chargeback Date & Time</FormInputError>
          </FormField>
        </Flex>
      </Flex>
    </Flex>
  );
};

export const ContentApprove1 = () => {
  const { contentApprove1_TreatmentType_List, contentApprove1_TreatmentType, setContentApprove1_TreatmentType } = useAdminApplicationDetailStore();
  const { contentApprove1_ClassificationOfSurgery_List, contentApprove1_ClassificationOfSurgery, setContentApprove1_ClassificationOfSurgery } = useAdminApplicationDetailStore();
  const { contentApprove1_ICD, setContentApprove1_ICD } = useAdminApplicationDetailStore();
  const { contentApprove1_ICD_code, setContentApprove1_ICD_code } = useAdminApplicationDetailStore();
  const { contentComposeEmail_Reason_List, contentApprove1_Remarks, setContentApprove1_Remarks } = useAdminApplicationDetailStore();
  const { contentApprove1_Remarks_text, setContentApprove1_RemarksText } = useAdminApplicationDetailStore();
  const { contentApprove1_savingAmount, setContentApprove1_savingAmount } = useAdminApplicationDetailStore();
  const { isValid_contentApprove1_TreatmentType, setIsValid_contentApprove1_TreatmentType } = useAdminApplicationDetailStore();
  const { isValid_contentApprove1_ClassificationOfSurgery, setIsValid_contentApprove1_ClassificationOfSurgery } = useAdminApplicationDetailStore();
  const { contentApprove1_ICD_code_list, admGetICDMaintenanceList } = useAdminApplicationDetailStore();

  const loadAdmGetICDMaintenanceList = withErrorHandling(admGetICDMaintenanceList);

  useEffect(() => {
    const loadICDList = async () => {
      await loadAdmGetICDMaintenanceList();
    }

    loadICDList();
  }, [admGetICDMaintenanceList]);

  return (
    <Flex gap={24} direction={"column"} alignItems={"flex-start"}>
      {/* <FormText>After this confirmation it will lead to finance handler for approval</FormText> */}

      <FormField style={{ width: "100%", marginBottom: 0 }}>
        <FormLabel>Treatment Type</FormLabel>
        <FormSelect
          placeholder={"Select the treatment type"}
          options={contentApprove1_TreatmentType_List}
          value={contentApprove1_TreatmentType}
          handleSelect={(value) => {
            setIsValid_contentApprove1_TreatmentType(true);
            setContentApprove1_TreatmentType(value);
          }}
        ></FormSelect>
        <FormInputError show={!isValid_contentApprove1_TreatmentType}>* 請選擇Treatment Type</FormInputError>
      </FormField>

      <FormField style={{ width: "100%", marginBottom: 0 }}>
        <FormLabel>Classification of Surgery</FormLabel>
        <FormSelect
          placeholder={"Select classification of surgery"}
          options={contentApprove1_ClassificationOfSurgery_List}
          value={contentApprove1_ClassificationOfSurgery}
          handleSelect={(value) => {
            setIsValid_contentApprove1_ClassificationOfSurgery(true);
            setContentApprove1_ClassificationOfSurgery(value);
          }}
        ></FormSelect>
        <FormInputError show={!isValid_contentApprove1_ClassificationOfSurgery}>* 請選擇Classification of Surgery</FormInputError>
      </FormField>

      <FormField style={{ width: "100%", marginBottom: 0 }}>
        <FormLabel htmlFor="diagnosis">Provide ICD Code</FormLabel>

        {
          !!contentApprove1_ICD ?
            <FormTextarea id="diagnosis" value={contentApprove1_ICD} onChange={(e) => { setContentApprove1_ICD(e.target.value); }} rows="5" placeholder="Please enter ICD Code" aria-label="Provide ICD Code" />
            :
            <Select
              mode="multiple"
              size={"large"}
              allowClear
              optionFilterProp="label"
              options={contentApprove1_ICD_code_list}
              value={contentApprove1_ICD_code_list?.length > 0 ? contentApprove1_ICD_code : []}
              onChange={(value) => {
                setContentApprove1_ICD_code(value);
              }}
              style={{
                width: "100%",
              }}
            />
        }
      </FormField>

      <FormField style={{ width: "100%", marginBottom: 0 }}>
        <FormLabel>Remarks</FormLabel>
        <Select
          mode="multiple"
          size={"large"}
          maxCount={3}
          allowClear
          optionFilterProp="label"
          options={contentComposeEmail_Reason_List.map((item) => {
            return {
              label: `${item.value} - ${item.label}`,
              value: item.value,
            }
          })}
          value={contentApprove1_Remarks}
          onChange={(value) => {
            setContentApprove1_Remarks(value);
          }}
          style={{
            width: "100%",
          }}
        />
        <Space height={8} />
        <FormTextarea id="" value={contentApprove1_Remarks_text} onChange={e => { setContentApprove1_RemarksText(e.target.value); }} rows="5" placeholder="Please enter Remarks" aria-label="Remarks" />
      </FormField>

      <FormField style={{ width: "100%", marginBottom: 0 }}>
        <FormLabel htmlFor="saving_amount">Saving amount</FormLabel>
        <FormInput id="saving_amount" prefix={"HK$"} type={"number"} min={"0"} onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()} value={contentApprove1_savingAmount} handleChange={e => { setContentApprove1_savingAmount(e.target.value); }} placeholder="Please enter Saving amount" aria-label="Saving amount" />
      </FormField>
    </Flex>
  );
};
export const ContentDecline1 = () => {
  const { contentApprove1_TreatmentType_List, contentApprove1_TreatmentType, setContentApprove1_TreatmentType } = useAdminApplicationDetailStore();
  const { contentApprove1_ClassificationOfSurgery_List, contentApprove1_ClassificationOfSurgery, setContentApprove1_ClassificationOfSurgery } = useAdminApplicationDetailStore();
  const { contentApprove1_ICD, setContentApprove1_ICD } = useAdminApplicationDetailStore();
  const { contentApprove1_ICD_code, setContentApprove1_ICD_code } = useAdminApplicationDetailStore();
  const { contentComposeEmail_Reason_List, contentApprove1_Remarks, setContentApprove1_Remarks } = useAdminApplicationDetailStore();
  const { contentApprove1_Remarks_text, setContentApprove1_RemarksText } = useAdminApplicationDetailStore();
  const { contentApprove1_savingAmount, setContentApprove1_savingAmount } = useAdminApplicationDetailStore();
  const { isValid_contentApprove1_TreatmentType, setIsValid_contentApprove1_TreatmentType } = useAdminApplicationDetailStore();
  const { isValid_contentApprove1_ClassificationOfSurgery, setIsValid_contentApprove1_ClassificationOfSurgery } = useAdminApplicationDetailStore();
  const { contentApprove1_ICD_code_list, admGetICDMaintenanceList } = useAdminApplicationDetailStore();

  const loadAdmGetICDMaintenanceList = withErrorHandling(admGetICDMaintenanceList);

  useEffect(() => {
    const loadICDList = async () => {
      await loadAdmGetICDMaintenanceList();
    }

    loadICDList();
  }, [admGetICDMaintenanceList]);

  return (
    <Flex gap={24} direction={"column"} alignItems={"flex-start"}>
      {/* <FormText>After this confirmation it will lead to finance handler for approval</FormText> */}

      <FormField style={{ width: "100%", marginBottom: 0 }}>
        <FormLabel>Treatment Type</FormLabel>
        <FormSelect
          placeholder={"Select the treatment type"}
          options={contentApprove1_TreatmentType_List}
          value={contentApprove1_TreatmentType}
          handleSelect={(value) => {
            setIsValid_contentApprove1_TreatmentType(true);
            setContentApprove1_TreatmentType(value);
          }}
        ></FormSelect>
        <FormInputError show={!isValid_contentApprove1_TreatmentType}>* 請選擇Treatment Type</FormInputError>
      </FormField>

      <FormField style={{ width: "100%", marginBottom: 0 }}>
        <FormLabel>Classification of Surgery</FormLabel>
        <FormSelect
          placeholder={"Select classification of surgery"}
          options={contentApprove1_ClassificationOfSurgery_List}
          value={contentApprove1_ClassificationOfSurgery}
          handleSelect={(value) => {
            setIsValid_contentApprove1_ClassificationOfSurgery(true);
            setContentApprove1_ClassificationOfSurgery(value);
          }}
        ></FormSelect>
        <FormInputError show={!isValid_contentApprove1_ClassificationOfSurgery}>* 請選擇Classification of Surgery</FormInputError>
      </FormField>

      <FormField style={{ width: "100%", marginBottom: 0 }}>
        <FormLabel htmlFor="diagnosis">Provide ICD Code</FormLabel>

        {
          !!contentApprove1_ICD ?
            <FormTextarea id="diagnosis" value={contentApprove1_ICD} onChange={(e) => { setContentApprove1_ICD(e.target.value); }} rows="5" placeholder="Please enter ICD Code" aria-label="Provide ICD Code" />
            :
            <Select
              mode="multiple"
              size={"large"}
              allowClear
              optionFilterProp="label"
              options={contentApprove1_ICD_code_list}
              value={contentApprove1_ICD_code_list?.length > 0 ? contentApprove1_ICD_code : []}
              onChange={(value) => {
                setContentApprove1_ICD_code(value);
              }}
              style={{
                width: "100%",
              }}
            />
        }
      </FormField>

      <FormField style={{ width: "100%", marginBottom: 0 }}>
        <FormLabel>Remarks</FormLabel>
        <Select
          mode="multiple"
          size={"large"}
          maxCount={3}
          allowClear
          optionFilterProp="label"
          options={contentComposeEmail_Reason_List.map((item) => {
            return {
              label: `${item.value} - ${item.label}`,
              value: item.value,
            }
          })}
          value={contentApprove1_Remarks}
          onChange={(value) => {
            setContentApprove1_Remarks(value);
          }}
          style={{
            width: "100%",
          }}
        />
        <Space height={8} />
        <FormTextarea id="" value={contentApprove1_Remarks_text} onChange={e => { setContentApprove1_RemarksText(e.target.value); }} rows="5" placeholder="Please enter Remarks" aria-label="Remarks" />
      </FormField>

      <FormField style={{ width: "100%", marginBottom: 0 }}>
        <FormLabel htmlFor="saving_amount">Saving amount</FormLabel>
        <FormInput id="saving_amount" prefix={"HK$"} type={"number"} min={"0"} onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()} value={contentApprove1_savingAmount} handleChange={e => { setContentApprove1_savingAmount(e.target.value); }} placeholder="Please enter Saving amount" aria-label="Saving amount" />
      </FormField>
    </Flex>
  );
};

export const ContentApprove2 = ({ isPCA }) => {
  const { data } = useAdminApplicationDetailStore();
  const { contentApprove2_Operation_List, contentApprove2_Operation, setContentApprove2_Operation, isValid_contentApprove2_Operation } = useAdminApplicationDetailStore();
  const { contentApprove2_Accommodation_List, contentApprove2_Accommodation, setContentApprove2_Accommodation, isValid_contentApprove2_Accommodation } = useAdminApplicationDetailStore();
  const { contentApprove2_BenefitType_List, contentApprove2_BenefitType, setContentApprove2_BenefitType, isValid_contentApprove2_BenefitType } = useAdminApplicationDetailStore();
  const { contentApprove2_lumpSumBenefitAmount, setContentApprove2_lumpSumBenefitAmount, isValid_contentApprove2_lumpSumBenefitAmount } = useAdminApplicationDetailStore();
  const { setIsValid_contentApprove2_Operation, setIsValid_contentApprove2_Accommodation, setIsValid_contentApprove2_BenefitType, setIsValid_contentApprove2_lumpSumBenefitAmount } = useAdminApplicationDetailStore.getState();
  const { contentBasicHospitalAndSurgicalBenefits_cnofdays, setContentBasicHospitalAndSurgicalBenefits_cnofdays, setIsValid_contentBasicHospitalAndSurgicalBenefits_cnofdays, isValid_contentBasicHospitalAndSurgicalBenefits_cnofdays } = useAdminApplicationDetailStore.getState();
  const { contentSMMBenefit_overallLimit_type_list, contentSMMBenefit_overallLimit_type, setContentSMMBenefit_overallLimitType } = useAdminApplicationDetailStore();
  const { contentSMMBenefit_overallLimit, setContentSMMBenefit_overallLimit ,isValid_contentSMMBenefit_overallLimit_type,setIsValid_contentSMMBenefit_overallLimit_type} = useAdminApplicationDetailStore();
  return (
    <Flex gap={24} direction={"column"} alignItems={"flex-start"}>
      <FormText>After this confirmation it will lead to finance handler for approval</FormText>

      {
        isPCA &&
        <FormField style={{ width: "100%", marginBottom: 0 }}>
          <FormLabel>Your operation is classified as:</FormLabel>
          <FormSelect
            placeholder={"Please Select"}
            options={contentApprove2_Operation_List}
            value={contentApprove2_Operation}
            handleSelect={(value) => {
              setContentApprove2_Operation(value);
              setIsValid_contentApprove2_Operation(true);
            }}
          ></FormSelect>
          <FormInputError show={!isValid_contentApprove2_Operation}>* 請選擇Your operation</FormInputError>
        </FormField>
      }

      <FormField style={{ width: "100%", marginBottom: 0 }}>
        <FormLabel>Entitled Level of Accommodation</FormLabel>
        <FormSelect
          placeholder={"Please Select"}
          options={contentApprove2_Accommodation_List}
          value={contentApprove2_Accommodation}
          handleSelect={(value) => {
            setContentApprove2_Accommodation(value);
            setIsValid_contentApprove2_Accommodation(true);
          }}
        ></FormSelect>
        <FormInputError show={!isValid_contentApprove2_Accommodation}>* 請選擇Entitled Level of Accommodation</FormInputError>
      </FormField>

      <Flex width={400} direction={"column"} alignItems={"flex-start"} gap={8}>
        <FormTitle>Estimated Expenses</FormTitle>
        <Flex width={"100%"} justifyContent={"space-between"} alignItems={"flex-start"}>
          <FormText>Surgeon's Fee</FormText>
          <Flex>
            <FormRemark>HK$</FormRemark>
            <FormText>{formatCurrency(data?.form?.surgeonfee)}</FormText>
          </Flex>
        </Flex>
        <Flex width={"100%"} justifyContent={"space-between"} alignItems={"flex-start"}>
          <FormText>Anaesthetist's Fee</FormText>
          <Flex>
            <FormRemark>HK$</FormRemark>
            <FormText>{formatCurrency(data?.form?.anesthesiologistfee)}</FormText>
          </Flex>
        </Flex>
        <Flex width={"100%"} justifyContent={"space-between"} alignItems={"flex-start"}>
          <FormText>Operating Theatre</FormText>
          <Flex>
            <FormRemark>HK$</FormRemark>
            <FormText>{formatCurrency(data?.form?.operatingrmfee)}</FormText>
          </Flex>
        </Flex>
        <Flex width={"100%"} justifyContent={"space-between"} alignItems={"flex-start"}>
          <FormText>Miscellaneous Hospital Charges</FormText>
          <Flex>
            <FormRemark>HK$</FormRemark>
            <FormText>{formatCurrency(data?.form?.hosmisousfee)}</FormText>
          </Flex>
        </Flex>
        <Flex width={"100%"} justifyContent={"space-between"} alignItems={"flex-start"}>
          <FormText>Physician's Hospital Visit (Per Days)</FormText>
          <Flex>
            <FormRemark>HK$</FormRemark>
            <FormText>{formatCurrency(data?.form?.housetourfee)}</FormText>
          </Flex>
        </Flex>
        <Flex width={"100%"} justifyContent={"space-between"} alignItems={"flex-start"}>
          <FormText>Days in Hospital number</FormText>
          <Flex>
            <FormText>{data?.form?.noofdays}</FormText>
            <FormRemark>days</FormRemark>
          </Flex>
        </Flex>
        <HDivider />
        <Flex width={"100%"} justifyContent={"space-between"} alignItems={"flex-start"}>
          <FormText style={{ fontWeight: "bold" }}>Lump Sum Expenses</FormText>
          <Flex>
            <FormRemark>HK$</FormRemark>
            <FormText>{formatCurrency(parseFloat(data?.form?.surgeonfee ?? 0) + (parseFloat(data?.form?.anesthesiologistfee ?? 0)) + (parseFloat(data?.form?.operatingrmfee ?? 0)) + (parseFloat(data?.form?.hosmisousfee ?? 0)) + (((parseFloat(data?.form?.housetourfee ?? 0))) * (parseFloat(data?.form?.noofdays ?? 0))))}</FormText>
          </Flex>
        </Flex>
      </Flex>
      <FormField style={{ width: "100%", marginBottom: 0 }}>
            <FormLabel>Limit Type</FormLabel>
            <FormSelect
              placeholder={"Please select"}
              options={contentSMMBenefit_overallLimit_type_list}
              value={contentSMMBenefit_overallLimit_type}
              handleSelect={(value) => {
                setContentSMMBenefit_overallLimitType(value);
                setIsValid_contentSMMBenefit_overallLimit_type(true);
              }}
            ></FormSelect> 
               <FormInputError show={!isValid_contentSMMBenefit_overallLimit_type}>* 請選擇Limit Type</FormInputError>
            <Space height={8} />
            {/* <FormInput prefix={"HK$"} type={"number"} min={"0"} onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()} value={contentSMMBenefit_overallLimit} handleChange={e => { setContentSMMBenefit_overallLimit(e.target.value); }} placeholder="Please enter Overall Limit / Balance of SMM" aria-label="Overall Limit / Balance of SMM" /> */}
          </FormField>
      <FormField style={{ width: "100%", marginBottom: 0 }}>
        <FormLabel>Benefit Type</FormLabel>
        <FormSelect
          placeholder={"Please Select"}
          options={contentApprove2_BenefitType_List}
          value={contentApprove2_BenefitType}
          handleSelect={(value) => {
            setContentApprove2_BenefitType(value);
            setIsValid_contentApprove2_BenefitType(true);
          }}
        ></FormSelect>
        <FormInputError show={!isValid_contentApprove2_BenefitType}>* 請選擇Benefit Type</FormInputError>
      </FormField>

      {
        contentApprove2_BenefitType?.value === "Lum Sum Benefit" &&
        <>
          <FormField style={{ width: "100%", marginBottom: 0 }}>
            <FormLabel htmlFor="Lump_sum_benefit_amount">Lump Sum Benefit Amount</FormLabel>
            <FormInput type={"number"} prefix={"HK$"} min={"0"} onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()} id="Lump_sum_benefit_amount" value={contentApprove2_lumpSumBenefitAmount} handleChange={e => {
              setContentApprove2_lumpSumBenefitAmount(e.target.value);
              setIsValid_contentApprove2_lumpSumBenefitAmount(true);
            }} placeholder="0" aria-label="Lump Sum Benefit Amount" />
            <FormInputError show={!isValid_contentApprove2_lumpSumBenefitAmount}>* Please enter Lump Sum Benefit Amount</FormInputError>
          </FormField>
          <Flex justifyContent={""} alignItems={"flex-start"} gap={8} width={"100%"}>
            <FormField style={{ width: "100%", marginBottom: 0 }}>
              <FormLabel htmlFor="cnofdays">Days in Hospital number</FormLabel>
              <FormInput id="cnofdays" type={"number"} min={"0"} onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()} suffix={"days"} value={contentBasicHospitalAndSurgicalBenefits_cnofdays} handleChange={e => { setContentBasicHospitalAndSurgicalBenefits_cnofdays(e.target.value); setIsValid_contentBasicHospitalAndSurgicalBenefits_cnofdays(true); }} placeholder="0" aria-label="住院日數" />
              <FormInputError show={!isValid_contentBasicHospitalAndSurgicalBenefits_cnofdays}>* Please enter Days in Hospital number</FormInputError>
            </FormField>
          </Flex>
        </>
      }
    </Flex>
  );
};

export const ContentApprove3 = () => {
  const { contentApprove3_roomClass_option1, contentApprove3_roomClass_option2, contentApprove3_roomClass_option3, isValid_contentApprove3_roomClass_option } = useAdminApplicationDetailStore();
  const { setContentApprove3_roomClass_option1, setContentApprove3_roomClass_option2, setContentApprove3_roomClass_option3 } = useAdminApplicationDetailStore();
  const { contentApprove3_logAmount, setContentApprove3_logAmount, isValid_contentApprove3_logAmount, setIsValid_contentApprove3_logAmount } = useAdminApplicationDetailStore();

  const handleRoomClassOptionClick = (option) => {
    setIsValid_contentApprove3_logAmount(true);
    setContentApprove3_roomClass_option1(option === 1);
    setContentApprove3_roomClass_option2(option === 2);
    setContentApprove3_roomClass_option3(option === 3);
  };

  return (
    <Flex gap={24} direction={"column"} alignItems={"flex-start"}>
      <FormText>After this confirmation it will lead to finance handler for approval</FormText>

      {/* <FormField style={{ width: "auto", marginBottom: 0 }}>
        <FormLabel>Entitled Room Class</FormLabel>
        <Flex style={{ flexWrap: "wrap" }}>
          <FormRadioButton onClick={() => { handleRoomClassOptionClick(1) }} active={contentApprove3_roomClass_option1}>Ward</FormRadioButton>
          <FormRadioButton onClick={() => { handleRoomClassOptionClick(2) }} active={contentApprove3_roomClass_option2}>Semi-private</FormRadioButton>
          <FormRadioButton onClick={() => { handleRoomClassOptionClick(3) }} active={contentApprove3_roomClass_option3}>Private</FormRadioButton>
        </Flex>
        <FormInputError show={!isValid_contentApprove3_roomClass_option}>* 請選擇Entitled Room Class</FormInputError>
      </FormField> */}

      <FormField style={{ width: "100%", marginBottom: 0 }}>
        <FormLabel htmlFor="log_amount">LOG amount</FormLabel>
        <FormInput id="log_amount" type={"number"} min={"0"} onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()} prefix={"HK$"} value={contentApprove3_logAmount} handleChange={e => { setContentApprove3_logAmount(e.target.value); setIsValid_contentApprove3_logAmount(true); }} placeholder="0" aria-label="LOG amount" />
        <FormInputError show={!isValid_contentApprove3_logAmount}>* Please enter LOG amount</FormInputError>
      </FormField>
    </Flex>
  );
};

export const ContentClaimRequest = () => {
  const { contentClaimRequest_Incurred_amount, setContentClaimRequest_Incurred_amount, isValid_contentClaimRequest_Incurred_amount, setIsValid_contentClaimRequest_Incurred_amount } = useAdminApplicationDetailStore();
  const { contentClaimRequest_paid_amount, setContentClaimRequest_paid_amount, isValid_contentClaimRequest_paid_amount, setIsValid_contentClaimRequest_paid_amount } = useAdminApplicationDetailStore();
  const { contentClaimRequest_chargeback, setContentClaimRequest_chargeback, isValid_contentClaimRequest_chargeback, setIsValid_contentClaimRequest_chargeback } = useAdminApplicationDetailStore();
  const { contentClaimRequest_wis_no, setContentClaimRequest_wis_no, isValid_contentClaimRequest_wis_no, setIsValid_contentClaimRequest_wis_no } = useAdminApplicationDetailStore();
  const { contentClaimRequest_debit_no, setContentClaimRequest_debit_no, isValid_contentClaimRequest_debit_no, setIsValid_contentClaimRequest_debit_no } = useAdminApplicationDetailStore();
  const { data } = useAdminApplicationDetailStore();

  return (
    <Flex gap={24} direction={"column"} alignItems={"flex-start"}>
      <FormText>After this confirmation it will lead to finance handler for approval</FormText>

      <Flex alignItems={"flex-start"} gap={40} style={{ flexWrap: "wrap", minWidth: 600 }}>
        <Flex direction={"column"} alignItems={"flex-start"}>
          <FormRemark>LOG Amount</FormRemark>
          <FormText>HK$ {formatCurrency(data?.claim?.LOGAmt) ?? "-"}</FormText>
        </Flex>
        <Flex direction={"column"} alignItems={"flex-start"}>
          <FormRemark>Hold Amount</FormRemark>
          <FormText>HK$ {formatCurrency(5000)}</FormText>
        </Flex>
      </Flex>

      <Flex direction={"column"} alignItems={"flex-start"} gap={16} width={"100%"}>
        <Flex justifyContent={"space-between"} alignItems={"flex-start"} gap={8} width={"100%"}>
          <FormField style={{ flex: 1, marginBottom: 0 }}>
            <FormLabel htmlFor="incurred_amount">Incurred Amount</FormLabel>
            <FormInput id="incurred_amount" type={"number"} min={"0"} onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()} prefix={"HK$"} value={contentClaimRequest_Incurred_amount} handleChange={e => { setContentClaimRequest_Incurred_amount(e.target.value); setIsValid_contentClaimRequest_Incurred_amount(true); }} placeholder="0" aria-label="Incurred Amount" />
            <FormInputError show={!isValid_contentClaimRequest_Incurred_amount}>* Please enter Incurred Amount</FormInputError>
          </FormField>
          <FormField style={{ flex: 1, marginBottom: 0 }}>
            <FormLabel htmlFor="paid_amount">Eligible Amount</FormLabel>
            <FormInput id="paid_amount" type={"number"} min={"0"} onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()} prefix={"HK$"} value={contentClaimRequest_paid_amount} handleChange={e => { setContentClaimRequest_paid_amount(e.target.value); setIsValid_contentClaimRequest_paid_amount(true); }} placeholder="0" aria-label="Eligible Amount" />
            <FormInputError show={!isValid_contentClaimRequest_paid_amount}>* Please enter Eligible Amount</FormInputError>
          </FormField>
        </Flex>
        <Flex justifyContent={"space-between"} alignItems={"flex-start"} gap={8} width={"100%"}>
          <FormField style={{ flex: 1, marginBottom: 0 }}>
            <FormLabel htmlFor="chargeback">Chargeback</FormLabel>
            <FormInput
              id="chargeback"
              min={"0"}
              // max={"5000"}
              onKeyDown={(event) => {
                const { key, target } = event;
                const { selectionStart, selectionEnd, value } = target;

                // Allow control keys
                if (['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(key)) return;

                // Prevent non-numeric keys and 'e'
                if (key === '-' || key === 'e' || (key === '.' && value.includes('.')) || (!/^\d*\.?\d*$/.test(value + key))) {
                  event.preventDefault();
                  return;
                }

                // Construct the potential new value considering the selection
                // let potentialValueStr = value.slice(0, selectionStart) + key + value.slice(selectionEnd);
                // let potentialValue = parseFloat(potentialValueStr);

                // Check if the potential value is numeric and larger than 5000
                // if (!isNaN(potentialValue) && potentialValue > 5000) {
                //   event.preventDefault(); // Prevent the key press
                // }
              }} prefix={"HK$"} value={contentClaimRequest_chargeback} handleChange={e => { setContentClaimRequest_chargeback(e.target.value); setIsValid_contentClaimRequest_chargeback(true); }} placeholder="0" aria-label="Chargeback" />
            <FormInputError show={!isValid_contentClaimRequest_chargeback}>* Please enter Chargeback</FormInputError>
          </FormField>
          <FormField style={{ flex: 1, marginBottom: 0 }}>
            <FormLabel htmlFor="wis_no">WIS No.</FormLabel>
            <FormInput id="wis_no" value={contentClaimRequest_wis_no} handleChange={e => { setContentClaimRequest_wis_no(e.target.value); setIsValid_contentClaimRequest_wis_no(true); }} placeholder="" aria-label="WIS No." />
            <FormInputError show={!isValid_contentClaimRequest_wis_no}>* Please enter WIS No.</FormInputError>
          </FormField>
        </Flex>
        <Flex justifyContent={"space-between"} alignItems={"flex-start"} gap={8} width={"100%"}>
          <FormField style={{ flex: 1, marginBottom: 0 }}>
            <FormLabel htmlFor="debit_no">Debit no.</FormLabel>
            <FormInput id="debit_no" value={contentClaimRequest_debit_no} handleChange={e => { setContentClaimRequest_debit_no(e.target.value); setIsValid_contentClaimRequest_debit_no(true); }} placeholder="" aria-label="Debit No" />
            <FormInputError show={!isValid_contentClaimRequest_debit_no}>* Please enter Debit no.</FormInputError>
          </FormField>
        </Flex>
      </Flex>
    </Flex>
  );
};

export const ContentSMMBenefit = () => {
  const { contentSMMBenefit_fillInSMMDetail, setContentSMMBenefit_fillInSMMDetail } = useAdminApplicationDetailStore();
  const { contentComposeEmail_Reason_List, contentSMMBenefit_remarks, setContentSMMBenefit_remarks, contentSMMBenefit_remarks_text, setContentSMMBenefit_remarksText } = useAdminApplicationDetailStore();
  const { contentSMMBenefit_deductibleAmount, setContentSMMBenefit_deductibleAmount } = useAdminApplicationDetailStore();
  const { contentSMMBenefit_reimbursementPercentage, setContentSMMBenefit_reimbursementPercentage } = useAdminApplicationDetailStore();
  const { contentSMMBenefit_overallLimit, setContentSMMBenefit_overallLimit } = useAdminApplicationDetailStore();
  // const { contentSMMBenefit_overallLimit_type_list, contentSMMBenefit_overallLimit_type, setContentSMMBenefit_overallLimitType } = useAdminApplicationDetailStore();

  const handleCheckboxClick = () => {
    setContentSMMBenefit_fillInSMMDetail(!contentSMMBenefit_fillInSMMDetail);
  };

  return (
    <Flex gap={24} direction={"column"} alignItems={"flex-start"}>
      <FormText>After this confirmation it will lead to finance handler for approval</FormText>

      <FormCheckbox active={contentSMMBenefit_fillInSMMDetail} onClick={handleCheckboxClick}>Fill in SMM Detail</FormCheckbox>

      {
        contentSMMBenefit_fillInSMMDetail &&
        <>
          <FormField style={{ width: "100%", marginBottom: 0 }}>
            <FormLabel htmlFor="deductible_amount">Deductible Amount</FormLabel>
            <FormInput id="deductible_amount" prefix={"HK$"} type={"number"} min={"0"} onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()} value={contentSMMBenefit_deductibleAmount} handleChange={e => { setContentSMMBenefit_deductibleAmount(e.target.value); }} placeholder="Please enter Deductible Amount" aria-label="Deductible Amount" />
          </FormField>
          <FormField style={{ width: "100%", marginBottom: 0 }}>
            <FormLabel htmlFor="deductible_reimbursementPercentage">Reimbursement Percentage</FormLabel>
            <FormInput id="deductible_reimbursementPercentage" suffix={"%"} type={"number"} min={"0"} onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()} value={contentSMMBenefit_reimbursementPercentage} handleChange={e => { setContentSMMBenefit_reimbursementPercentage(e.target.value); }} placeholder="Please enter Reimbursement Percentage" aria-label="Reimbursement Percentage" />
          </FormField>
          <FormField style={{ width: "100%", marginBottom: 0 }}>
            {/* <FormLabel>Overall Limit / Balance of SMM</FormLabel>
            <FormSelect
              placeholder={"Please Limit Type"}
              options={contentSMMBenefit_overallLimit_type_list}
              value={contentSMMBenefit_overallLimit_type}
              handleSelect={(value) => {
                setContentSMMBenefit_overallLimitType(value);
              }}
            ></FormSelect>
            <Space height={8} /> */}
            <FormLabel>Balance of SMM</FormLabel>
            <FormInput prefix={"HK$"} type={"number"} min={"0"} onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()} value={contentSMMBenefit_overallLimit} handleChange={e => { setContentSMMBenefit_overallLimit(e.target.value); }} placeholder="Please enter Balance of SMM" aria-label="Overall Limit / Balance of SMM" />
          </FormField>
        </>
      }

      <FormField style={{ width: "100%", marginBottom: 0 }}>
        <FormLabel htmlFor="remarks">Remarks</FormLabel>
        <Select
          mode="multiple"
          size={"large"}
          maxCount={3}
          allowClear
          optionFilterProp="label"
          options={contentComposeEmail_Reason_List.map((item) => {
            return {
              label: `${item.value} - ${item.label}`,
              value: item.value,
            }
          })}
          value={contentSMMBenefit_remarks}
          onChange={(value) => {
            setContentSMMBenefit_remarks(value);
          }}
          style={{
            width: "100%",
          }}
        />
        <Space height={8} />
        <FormTextarea id="remarks" value={contentSMMBenefit_remarks_text} onChange={e => { setContentSMMBenefit_remarksText(e.target.value); }} rows="5" placeholder="Please enter Remarks" aria-label="Remarks" />
      </FormField>
    </Flex>
  );
};

export const ContentBasicHospitalAndSurgicalBenefits = () => {
  const { data } = useAdminApplicationDetailStore();
  const { contentBasicHospitalAndSurgicalBenefits_surgeon_fee, setContentBasicHospitalAndSurgicalBenefits_surgeon_fee, isValid_contentBasicHospitalAndSurgicalBenefits_surgeon_fee } = useAdminApplicationDetailStore();
  const { contentBasicHospitalAndSurgicalBenefits_surgeon_fee_remark, setContentBasicHospitalAndSurgicalBenefits_surgeon_fee_remark } = useAdminApplicationDetailStore();
  const { contentBasicHospitalAndSurgicalBenefits_anaesthetist_fee, setContentBasicHospitalAndSurgicalBenefits_anaesthetist_fee, isValid_contentBasicHospitalAndSurgicalBenefits_anaesthetist_fee } = useAdminApplicationDetailStore();
  const { contentBasicHospitalAndSurgicalBenefits_anaesthetist_fee_remark, setContentBasicHospitalAndSurgicalBenefits_anaesthetist_fee_remark } = useAdminApplicationDetailStore();
  const { contentBasicHospitalAndSurgicalBenefits_operating_theatre, setContentBasicHospitalAndSurgicalBenefits_operating_theatre, isValid_contentBasicHospitalAndSurgicalBenefits_operating_theatre } = useAdminApplicationDetailStore();
  const { contentBasicHospitalAndSurgicalBenefits_operating_theatre_remark, setContentBasicHospitalAndSurgicalBenefits_operating_theatre_remark } = useAdminApplicationDetailStore();
  const { contentBasicHospitalAndSurgicalBenefits_miscellaneous_hospital_charges, setContentBasicHospitalAndSurgicalBenefits_miscellaneous_hospital_charges, isValid_contentBasicHospitalAndSurgicalBenefits_miscellaneous_hospital_charges } = useAdminApplicationDetailStore();
  const { contentBasicHospitalAndSurgicalBenefits_miscellaneous_hospital_charges_remark, setContentBasicHospitalAndSurgicalBenefits_miscellaneous_hospital_charges_remark } = useAdminApplicationDetailStore();
  const { contentBasicHospitalAndSurgicalBenefits_physician_hospital_visit, setContentBasicHospitalAndSurgicalBenefits_physician_hospital_visit, isValid_contentBasicHospitalAndSurgicalBenefits_physician_hospital_visit } = useAdminApplicationDetailStore();
  const { contentBasicHospitalAndSurgicalBenefits_physician_hospital_visit_remark, setContentBasicHospitalAndSurgicalBenefits_physician_hospital_visit_remark } = useAdminApplicationDetailStore();
  const { setIsValid_contentBasicHospitalAndSurgicalBenefits_surgeon_fee, setIsValid_contentBasicHospitalAndSurgicalBenefits_anaesthetist_fee, setIsValid_contentBasicHospitalAndSurgicalBenefits_operating_theatre, setIsValid_contentBasicHospitalAndSurgicalBenefits_miscellaneous_hospital_charges, setIsValid_contentBasicHospitalAndSurgicalBenefits_physician_hospital_visit } = useAdminApplicationDetailStore();
  const { contentBasicHospitalAndSurgicalBenefits_cnofdays, setContentBasicHospitalAndSurgicalBenefits_cnofdays, isValid_contentBasicHospitalAndSurgicalBenefits_cnofdays, setIsValid_contentBasicHospitalAndSurgicalBenefits_cnofdays } = useAdminApplicationDetailStore();
  const { contentBasicHospitalAndSurgicalBenefits_room_and_board, setContentBasicHospitalAndSurgicalBenefits_room_and_board, isValid_contentBasicHospitalAndSurgicalBenefits_room_and_board, setIsValid_contentBasicHospitalAndSurgicalBenefits_room_and_board } = useAdminApplicationDetailStore();
  const { contentBasicHospitalAndSurgicalBenefits_room_and_board_remark, setContentBasicHospitalAndSurgicalBenefits_room_and_board_remark } = useAdminApplicationDetailStore();


  return (
    <Flex gap={24} direction={"column"} alignItems={"flex-start"}>
      <FormText>After this confirmation it will lead to finance handler for approval</FormText>

      <Flex width={400} direction={"column"} alignItems={"flex-start"} gap={8}>
        <FormTitle>Estimated Expenses</FormTitle>
        <Flex width={"100%"} justifyContent={"space-between"} alignItems={"flex-start"}>
          <FormText>Surgeon's Fee</FormText>
          <Flex>
            <FormRemark>HK$</FormRemark>
            <FormText>{formatCurrency(data?.form?.surgeonfee)}</FormText>
          </Flex>
        </Flex>
        <Flex width={"100%"} justifyContent={"space-between"} alignItems={"flex-start"}>
          <FormText>Anaesthetist's Fee</FormText>
          <Flex>
            <FormRemark>HK$</FormRemark>
            <FormText>{formatCurrency(data?.form?.anesthesiologistfee)}</FormText>
          </Flex>
        </Flex>
        <Flex width={"100%"} justifyContent={"space-between"} alignItems={"flex-start"}>
          <FormText>Operating Theatre</FormText>
          <Flex>
            <FormRemark>HK$</FormRemark>
            <FormText>{formatCurrency(data?.form?.operatingrmfee)}</FormText>
          </Flex>
        </Flex>
        <Flex width={"100%"} justifyContent={"space-between"} alignItems={"flex-start"}>
          <FormText>Miscellaneous Hospital Charges</FormText>
          <Flex>
            <FormRemark>HK$</FormRemark>
            <FormText>{formatCurrency(data?.form?.hosmisousfee)}</FormText>
          </Flex>
        </Flex>
        <Flex width={"100%"} justifyContent={"space-between"} alignItems={"flex-start"}>
          <FormText>Physician's Hospital Visit (Per Days)</FormText>
          <Flex>
            <FormRemark>HK$</FormRemark>
            <FormText>{formatCurrency(data?.form?.housetourfee)}</FormText>
          </Flex>
        </Flex>
        <Flex width={"100%"} justifyContent={"space-between"} alignItems={"flex-start"}>
          <FormText>住院日數</FormText>
          <Flex>
            <FormText>{data?.form?.noofdays}</FormText>
            <FormRemark>日</FormRemark>
          </Flex>
        </Flex>
        <HDivider />
        <Flex width={"100%"} justifyContent={"space-between"} alignItems={"flex-start"}>
          <FormText style={{ fontWeight: "bold" }}>Lump Sum Expenses</FormText>
          <Flex>
            <FormRemark>HK$</FormRemark>
            <FormText>{formatCurrency(parseFloat(data?.form?.surgeonfee ?? 0) + (parseFloat(data?.form?.anesthesiologistfee ?? 0)) + (parseFloat(data?.form?.operatingrmfee ?? 0)) + (parseFloat(data?.form?.hosmisousfee ?? 0)) + (((parseFloat(data?.form?.housetourfee ?? 0))) * (parseFloat(data?.form?.noofdays ?? 0))))}</FormText>
          </Flex>
        </Flex>
      </Flex>

      <Flex direction={"column"} alignItems={"flex-start"} gap={8} width={"100%"}>
        <Flex justifyContent={""} alignItems={"flex-start"} gap={8} width={"100%"}>
          <FormField style={{ flex: 0, minWidth: 250, marginBottom: 0 }}>
            <FormLabel htmlFor="surgeon_fee">Surgeon's Fee</FormLabel>
            <FormInput id="surgeon_fee" type={"number"} min={"0"} onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()} prefix={"HK$"} value={contentBasicHospitalAndSurgicalBenefits_surgeon_fee} handleChange={e => { setContentBasicHospitalAndSurgicalBenefits_surgeon_fee(e.target.value); setIsValid_contentBasicHospitalAndSurgicalBenefits_surgeon_fee(true); }} placeholder="0" aria-label="Surgeon's Fee" />
            <FormInputError show={!isValid_contentBasicHospitalAndSurgicalBenefits_surgeon_fee}>* Please enter Surgeon's Fee</FormInputError>
          </FormField>
          <FormField style={{ flex: 1, marginBottom: 0 }}>
            <FormLabel htmlFor="surgeon_fee_remarks">Remarks</FormLabel>
            <FormInput id="surgeon_fee_remarks" value={contentBasicHospitalAndSurgicalBenefits_surgeon_fee_remark} handleChange={e => { setContentBasicHospitalAndSurgicalBenefits_surgeon_fee_remark(e.target.value); }} placeholder="" aria-label="Remarks for Surgeon's Fee" />
          </FormField>
        </Flex>
        <Flex justifyContent={""} alignItems={"flex-start"} gap={8} width={"100%"}>
          <FormField style={{ flex: 0, minWidth: 250, marginBottom: 0 }}>
            <FormLabel htmlFor="anaesthetist_fee">Anaesthetist's Fee</FormLabel>
            <FormInput id="anaesthetist_fee" type={"number"} min={"0"} onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()} prefix={"HK$"} value={contentBasicHospitalAndSurgicalBenefits_anaesthetist_fee} handleChange={e => { setContentBasicHospitalAndSurgicalBenefits_anaesthetist_fee(e.target.value); setIsValid_contentBasicHospitalAndSurgicalBenefits_anaesthetist_fee(true); }} placeholder="0" aria-label="Anaesthetist's Fee" />
            <FormInputError show={!isValid_contentBasicHospitalAndSurgicalBenefits_anaesthetist_fee}>* Please enter Anaesthetist's Fee</FormInputError>
          </FormField>
          <FormField style={{ flex: 1, marginBottom: 0 }}>
            <FormLabel htmlFor="anaesthetist_fee_remarks">Remarks</FormLabel>
            <FormInput id="anaesthetist_fee_remarks" value={contentBasicHospitalAndSurgicalBenefits_anaesthetist_fee_remark} handleChange={e => { setContentBasicHospitalAndSurgicalBenefits_anaesthetist_fee_remark(e.target.value); }} placeholder="" aria-label="Remarks for Anaesthetist's Fee" />
          </FormField>
        </Flex>
        <Flex justifyContent={""} alignItems={"flex-start"} gap={8} width={"100%"}>
          <FormField style={{ flex: 0, minWidth: 250, marginBottom: 0 }}>
            <FormLabel htmlFor="operating_theatre">Operating Theatre</FormLabel>
            <FormInput id="operating_theatre" type={"number"} min={"0"} onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()} prefix={"HK$"} value={contentBasicHospitalAndSurgicalBenefits_operating_theatre} handleChange={e => { setContentBasicHospitalAndSurgicalBenefits_operating_theatre(e.target.value); setIsValid_contentBasicHospitalAndSurgicalBenefits_operating_theatre(true); }} placeholder="0" aria-label="Operating Theatre" />
            <FormInputError show={!isValid_contentBasicHospitalAndSurgicalBenefits_operating_theatre}>* Please enter Operating Theatre</FormInputError>
          </FormField>
          <FormField style={{ flex: 1, marginBottom: 0 }}>
            <FormLabel htmlFor="operating_theatre_remarks">Remarks</FormLabel>
            <FormInput id="operating_theatre_remarks" value={contentBasicHospitalAndSurgicalBenefits_operating_theatre_remark} handleChange={e => { setContentBasicHospitalAndSurgicalBenefits_operating_theatre_remark(e.target.value); }} placeholder="" aria-label="Remarks for Operating Theatre" />
          </FormField>
        </Flex>
        <Flex justifyContent={""} alignItems={"flex-start"} gap={8} width={"100%"}>
          <FormField style={{ flex: 0, minWidth: 250, marginBottom: 0 }}>
            <FormLabel htmlFor="miscellaneous_hospital_charges">Miscellaneous Hospital Charges</FormLabel>
            <FormInput id="miscellaneous_hospital_charges" type={"number"} min={"0"} onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()} prefix={"HK$"} value={contentBasicHospitalAndSurgicalBenefits_miscellaneous_hospital_charges} handleChange={e => { setContentBasicHospitalAndSurgicalBenefits_miscellaneous_hospital_charges(e.target.value); setIsValid_contentBasicHospitalAndSurgicalBenefits_miscellaneous_hospital_charges(true); }} placeholder="0" aria-label="Miscellaneous Hospital Charges" />
            <FormInputError show={!isValid_contentBasicHospitalAndSurgicalBenefits_miscellaneous_hospital_charges}>* Please enter Miscellaneous Hospital Charges</FormInputError>
          </FormField>
          <FormField style={{ flex: 1, marginBottom: 0 }}>
            <FormLabel htmlFor="miscellaneous_hospital_charges_remarks">Remarks</FormLabel>
            <FormInput id="miscellaneous_hospital_charges_remarks" value={contentBasicHospitalAndSurgicalBenefits_miscellaneous_hospital_charges_remark} handleChange={e => { setContentBasicHospitalAndSurgicalBenefits_miscellaneous_hospital_charges_remark(e.target.value); }} placeholder="" aria-label="Remarks for Miscellaneous Hospital Charges" />
          </FormField>
        </Flex>
        <Flex justifyContent={""} alignItems={"flex-start"} gap={8} width={"100%"}>
          <FormField style={{ flex: 0, minWidth: 250, marginBottom: 0 }}>
            <FormLabel htmlFor="physician_hospital_visit">Physician's Hospital Visit (Per Days)</FormLabel>
            <FormInput id="physician_hospital_visit" type={"number"} min={"0"} onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()} prefix={"HK$"} value={contentBasicHospitalAndSurgicalBenefits_physician_hospital_visit} handleChange={e => { setContentBasicHospitalAndSurgicalBenefits_physician_hospital_visit(e.target.value); setIsValid_contentBasicHospitalAndSurgicalBenefits_physician_hospital_visit(true); }} placeholder="0" aria-label="Physician's Hospital Visit (Per Days)" />
            <FormInputError show={!isValid_contentBasicHospitalAndSurgicalBenefits_physician_hospital_visit}>* Please enter Physician's Hospital Visit (Per Days)</FormInputError>
          </FormField>
          <FormField style={{ flex: 1, marginBottom: 0 }}>
            <FormLabel htmlFor="physician_hospital_visit_remarks">Remarks</FormLabel>
            <FormInput id="physician_hospital_visit_remarks" value={contentBasicHospitalAndSurgicalBenefits_physician_hospital_visit_remark} handleChange={e => { setContentBasicHospitalAndSurgicalBenefits_physician_hospital_visit_remark(e.target.value); }} placeholder="" aria-label="Remarks for Physician's Hospital Visit (Per Days)" />
          </FormField>
        </Flex>
        <Flex justifyContent={""} alignItems={"flex-start"} gap={8} width={"100%"}>
          <FormField style={{ flex: 0, minWidth: 250, marginBottom: 0 }}>
            <FormLabel htmlFor="cnofdays">住院日數</FormLabel>
            <FormInput id="cnofdays" type={"number"} min={"0"} onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()} suffix={"日"} value={contentBasicHospitalAndSurgicalBenefits_cnofdays} handleChange={e => { setContentBasicHospitalAndSurgicalBenefits_cnofdays(e.target.value); setIsValid_contentBasicHospitalAndSurgicalBenefits_cnofdays(true); }} placeholder="0" aria-label="住院日數" />
            <FormInputError show={!isValid_contentBasicHospitalAndSurgicalBenefits_cnofdays}>* Please enter 住院日數</FormInputError>
          </FormField>
        </Flex>
        <Flex justifyContent={""} alignItems={"flex-start"} gap={8} width={"100%"}>
          <FormField style={{ flex: 0, minWidth: 250, marginBottom: 0 }}>
            <FormLabel htmlFor="room_and_board">Room and Board</FormLabel>
            <FormInput id="room_and_board" type={"number"} min={"0"} onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()} prefix={"HK$"} value={contentBasicHospitalAndSurgicalBenefits_room_and_board} handleChange={e => { setContentBasicHospitalAndSurgicalBenefits_room_and_board(e.target.value); setIsValid_contentBasicHospitalAndSurgicalBenefits_room_and_board(true); }} placeholder="0" aria-label="Room and Board" />
            <FormInputError show={!isValid_contentBasicHospitalAndSurgicalBenefits_room_and_board}>* Please enter Room and Board</FormInputError>
          </FormField>
          <FormField style={{ flex: 1, marginBottom: 0 }}>
            <FormLabel htmlFor="room_and_board_remarks">Remarks</FormLabel>
            <FormInput id="room_and_board_remarks" value={contentBasicHospitalAndSurgicalBenefits_room_and_board_remark} handleChange={e => { setContentBasicHospitalAndSurgicalBenefits_room_and_board_remark(e.target.value); }} placeholder="" aria-label="Remarks for Room and Board" />
          </FormField>
        </Flex>
      </Flex>
    </Flex>
  );
};

function ApplicationInfo() {
  const { t } = useTranslation();
  const { role } = useAuthAdminStore();
  const { admGetPreAuthForm, admChgPreAuthFormStatus ,ManualReleaseLimit } = useAdminApplicationDetailStore();
  const { openContentApprove1Modal, openContentApprove2Modal, openContentSUPPLEModal, openContentDeclineModal, openContentDeclineFirstModal,openContentClaimRequest, openContentScheduledChargeback } = useAdminApplicationDetailStore();
  const { data } = useAdminApplicationDetailStore();
  const { intstatusList, intstatus ,isLoadingAdmGetPreAuthForm } = useAdminApplicationDetailStore();
  const { aid } = useParams();
    
  // For STP
  const { contentApprove1_TreatmentType_List, setContentApprove1_TreatmentType } = useAdminApplicationDetailStore();
  const { contentApprove1_ClassificationOfSurgery_List, setContentApprove1_ClassificationOfSurgery } = useAdminApplicationDetailStore();
  const { setContentApprove1_ICD, setContentApprove1_ICD_code } = useAdminApplicationDetailStore();
  const { setContentApprove1_Remarks } = useAdminApplicationDetailStore();
  const { setContentApprove1_RemarksText } = useAdminApplicationDetailStore();
  const { setContentApprove1_savingAmount } = useAdminApplicationDetailStore();

  const { contentApprove2_Operation_List, setContentApprove2_Operation } = useAdminApplicationDetailStore();
  const { contentApprove2_Accommodation_List, setContentApprove2_Accommodation } = useAdminApplicationDetailStore();
  const { contentApprove2_BenefitType_List, setContentApprove2_BenefitType } = useAdminApplicationDetailStore();
  const { setContentApprove2_lumpSumBenefitAmount } = useAdminApplicationDetailStore();

  const { setContentBasicHospitalAndSurgicalBenefits_surgeon_fee, setContentBasicHospitalAndSurgicalBenefits_surgeon_fee_remark } = useAdminApplicationDetailStore();
  const { setContentBasicHospitalAndSurgicalBenefits_anaesthetist_fee, setContentBasicHospitalAndSurgicalBenefits_anaesthetist_fee_remark } = useAdminApplicationDetailStore();
  const { setContentBasicHospitalAndSurgicalBenefits_operating_theatre, setContentBasicHospitalAndSurgicalBenefits_operating_theatre_remark } = useAdminApplicationDetailStore();
  const { setContentBasicHospitalAndSurgicalBenefits_miscellaneous_hospital_charges, setContentBasicHospitalAndSurgicalBenefits_miscellaneous_hospital_charges_remark } = useAdminApplicationDetailStore();
  const { setContentBasicHospitalAndSurgicalBenefits_physician_hospital_visit, setContentBasicHospitalAndSurgicalBenefits_physician_hospital_visit_remark } = useAdminApplicationDetailStore();
  const { setContentBasicHospitalAndSurgicalBenefits_cnofdays } = useAdminApplicationDetailStore();
  const { setContentBasicHospitalAndSurgicalBenefits_room_and_board, setContentBasicHospitalAndSurgicalBenefits_room_and_board_remark } = useAdminApplicationDetailStore();

  const { setContentSMMBenefit_fillInSMMDetail, setContentSMMBenefit_deductibleAmount, setContentSMMBenefit_reimbursementPercentage, setContentSMMBenefit_overallLimitType, setContentSMMBenefit_overallLimit } = useAdminApplicationDetailStore();
  const { setContentSMMBenefit_remarks, setContentSMMBenefit_remarksText } = useAdminApplicationDetailStore();
  const { contentComposeEmail_Reason_List, contentSMMBenefit_overallLimit_type_list } = useAdminApplicationDetailStore();

  const isPCA = data?.form?.flowType === "PCA" || data?.form?.flowType === "CHGTOPCA";
  const isSTP = data?.form?.flowType === "STP";
  const isCSTeam = role === "CSADM" || role === "CSVIEW";

  const loadAdmGetPreAuthForm = withErrorHandling(admGetPreAuthForm);
  const updateStatus = withErrorHandling(admChgPreAuthFormStatus);

  useEffect(() => {
    loadAdmGetPreAuthForm(aid);
  }, []);

  //业务需求:  要禁用decline   超过14天的decline cancel要隐藏。禁止操作了。  
  // const [isDeclineOrCancelOver14Days,setIsDeclineOrCancelOver14Days]=useState(false)
  // const [isChangeToPCAStatusOver14Days,setSsChangeToPCAStatusOver14Days]=useState(false)
  // const timerRef = useRef(null);
  //  // 计时器逻辑
  // useEffect(() => {
  //   if (!data?.form?.intstatus || !data?.form?.moddt || isDeclineOrCancelOver14Days || isChangeToPCAStatusOver14Days) return;
  // //   if(['CANCELLED','DECLINED'].includes(data?.form?.intstatus)===false  && data?.form?.flowType!=='CHGTOPCA'){
  // //     //两个都false的时候，退出
  // //     return 
  // //  }

  //   const deadline = new Date(data?.form?.moddt?.replace(" ", "T"));
  //   const deadlinePlus14Days = new Date(deadline.getTime() + 14 * 24 * 60 * 60 * 1000);
  //   timerRef.current = setInterval(() => {
  //     const now = new Date(); 
  //     if (now >= deadlinePlus14Days) { // 超过拒绝、取消、CHGTOPCA的14天
  //       ['CANCELLED','DECLINED'].includes(data?.form?.intstatus) && setIsDeclineOrCancelOver14Days(true);
  //       data?.form?.flowType==='CHGTOPCA' && setSsChangeToPCAStatusOver14Days(true)
  //       clearInterval(timerRef.current);
  //     }
  //   }, 1000);

  //   return () => {
  //     clearInterval(timerRef.current); // 清除定时器，防止内存泄漏
  //   };
  // }, [data?.form?.intstatus,data?.form?.moddt,data?.form?.flowType]); //  依赖 deadline，因为它是异步获取的

  const statusOptionList = () => {
    // Remove "CHGTOPCA", "APPROVELOG", "PENDCHARGE", "SCHCHARGE", "CHARGESETTLE", "OUTCHARGE", "CLAIMSETTLE" option if the flow type is PCA
    const intstatusList_filter = (isPCA || isSTP) ? intstatusList.filter(option =>
      option.value !== "CHGTOPCA" &&
      option.value !== "APPROVELOG" &&
      option.value !== "PENDCHARGE" &&
      option.value !== "SCHCHARGE" &&
      option.value !== "CHARGESETTLE" &&
      option.value !== "OUTCHARGE" &&
      option.value !== "CLAIMSETTLE"
    ).map(item => {
      if (data?.form?.flowType === "STP" && item.value === "APPROVEPCA") {
        return {
          ...item,
          label: "Approved (STP)",
        }
      }

      return item;
    }) : intstatusList.filter(option =>
      option.value !== "CHGTOLOG" &&
      option.value !== "APPROVEPCA"
    );

    const intstatusList_filter_disabled = intstatusList_filter.map(option => {
      if (
        (
          data?.form?.intstatus === "NEW" ||
          data?.form?.intstatus === "SUPPLE" ||
          data?.form?.intstatus === "REVIEW" ||
          data?.form?.intstatus === "CHGTOPCA" ||
          data?.form?.intstatus === "DECLINED"
        )
        &&
        (
          option.value === "PENDCHARGE" ||
          option.value === "SCHCHARGE" ||
          option.value === "CHARGESETTLE" ||
          option.value === "OUTCHARGE" ||
          option.value === "CLAIMSETTLE"
        )
      ) {
        return {
          ...option,
          disabled: true,
        }
      } else if (
        data?.form?.intstatus === "APPROVELOG" &&
        (
          option.value === "SCHCHARGE" ||
          option.value === "CHARGESETTLE" ||
          option.value === "OUTCHARGE" ||
          option.value === "CLAIMSETTLE"
        )
      ) {
        return {
          ...option,
          disabled: true,
        }
      }

      return {
        ...option,
      }
    });

    // return intstatusList;
    return intstatusList_filter_disabled;
  }

  
 /**
 * 使用 dayjs 获取当前日期并加上指定天数
 * @param {number} daysToAdd - 要添加的天数（可以是正数或负数）
 * @returns {string} - 新的日期字符串（格式：YYYY-MM-DD）
 */
function addDaysWithDayjs(daysToAdd=14) {
  // 获取今天的日期，并加上指定的天数
  const newDate = dayjs().add(daysToAdd, 'day');

  // 格式化为 YYYY-MM-DD
  return newDate.format('YYYY-MM-DD');
}
  
  const { openModalInfo } = useModalStore.getState();
    /*--Alert success- */
  const alertSuccess = () => {
      Alert({
        type: "success",
        content: t("translation:admin.releaselimit.successMessage"),
      });
  };

  const handleMunalReleseLimit=async(aidParam,selectDate)=>{
    const res = await ManualReleaseLimit(aidParam, selectDate);
    if (res?.code === 4) {
      if (res?.errors?.find((item) => (item.errorCode = 111001))) {
        openModalInfo({
          id: isProduction ? "pre_auth_error_unLimit" : "pre_auth_uat_error_unLimit",
          // title: i18n.t("error:unauthorized_signin.title"),
          text: t("translation:admin.releaselimit.error111001"), //tbc wording
        });
      }
    }
    if (res?.code == 0 && res?.success === true) {
      admGetPreAuthForm(aid);
      alertSuccess()//tbc alert wording
    }
  }

  const [changeState, setChangeState] = useState(false);
  const prevValuesRef = useRef({
    intstatus: data?.form?.intstatus || null,
    flowType: data?.form?.flowType || null
  });
  useEffect(() => {
     // 如果 data 有值并且 prevValuesRef 还没初始化 
     if (data?.form && (!prevValuesRef.current.intstatus || !prevValuesRef.current.flowType )) {
       prevValuesRef.current = {
          intstatus: data?.form?.intstatus || null,
          flowType: data?.form?.flowType || null
       };
      console.log('初始化 prevValuesRef:', prevValuesRef.current);
     }
   }, [data?.form?.intstatus,data?.form?.flowType]);

  useEffect(() => {
    if (!changeState) return;
  
    const currInitStatus = data?.form?.intstatus;
    const currFlowType = data?.form?.flowType;
    const prevInitStatus = prevValuesRef.current.intstatus;
    const prevFlowType = prevValuesRef.current.flowType;
    // intstatus 变化
    if (currInitStatus && prevInitStatus && currInitStatus !== prevInitStatus) {
      console.log('intstatus 变化:', prevInitStatus, '→', currInitStatus);
       //如果变化的是cancel decline状态
      if (["CANCELLED", "DECLINED"].includes(currInitStatus)) {
        handleMunalReleseLimit(aid, addDaysWithDayjs());
      } else {
        handleMunalReleseLimit(aid, null);
      }
  
      prevValuesRef.current.intstatus = currInitStatus;
    }
  
    // flowType 变化
    if (currFlowType && prevFlowType && currFlowType !== prevFlowType) {
      console.log('flowType 变化:', prevFlowType, '→', currFlowType);
      //如果flowType是CHGTOPCA
      if (currFlowType === "CHGTOPCA") {
        handleMunalReleseLimit(aid, addDaysWithDayjs());
      } else {
        handleMunalReleseLimit(aid, null);
      }
  
      prevValuesRef.current.flowType = currFlowType;
    }
  }, [data?.form?.intstatus, data?.form?.flowType, changeState]); 

  
// ==== 1) 基础就绪态 ====
const hasIntstatus = !!data?.form?.intstatus;
const hasFlowType  = !!data?.form?.flowType;
const isLoading    = isLoadingAdmGetPreAuthForm;
const isReady      = !isLoading && hasIntstatus && hasFlowType;

// ==== 2) 无轮询的一次性 14 天判断 ====
const isDeclineOrCancelOver14Days = React.useMemo(() => {
  if (!data?.form?.moddt) return false;
  const deadline = new Date(data.form.moddt.replace(" ", "T"));
  const plus14   = new Date(deadline.getTime() + 14 * 24 * 60 * 60 * 1000);
  return (new Date() >= plus14) && ['CANCELLED','DECLINED'].includes(data?.form?.intstatus || '') && ['LOG'].includes(data?.form?.flowType);
}, [data?.form?.moddt, data?.form?.intstatus]);

  
const isChangeToPCAStatusOver14Days = React.useMemo(() => {
  if (!data?.form?.moddt) return false;
  const deadline = new Date(data.form.moddt.replace(" ", "T"));
  const plus14   = new Date(deadline.getTime() + 14 * 24 * 60 * 60 * 1000);
  return (new Date() >= plus14) && data?.form?.flowType === 'CHGTOPCA';
}, [data?.form?.moddt, data?.form?.flowType]);


// ==== 3) 统一计算稳定 disabled ====
const disabledStable = React.useMemo(() => {
  if (!isReady) return true;
  return (
    isCSTeam ||
    isDeclineOrCancelOver14Days ||
    isChangeToPCAStatusOver14Days
  );
}, [isReady, isCSTeam, isDeclineOrCancelOver14Days, isChangeToPCAStatusOver14Days]);

  return (
    <Container>
      <Flex flex={1} style={{ flexWrap: "wrap", rowGap: 8, columnGap: 32 }}>
        <FormHeader style={{ margin: 0 }} title={t("translation:admin.request.list_field.refno")}>{data?.form?.refno ?? t("translation:admin.request.list_field.refno")}</FormHeader>

        <Flex gap={8} direction={"column"} alignItems={"flex-start"}>
          <FormTitle title={t("translation:admin.request.list_field.insured_name")}>{data?.user?.fullname ?? "-"}</FormTitle>

          <Flex direction={"row"} style={{ flexWrap: "wrap", columnGap: 32 }}>
            <Flex>
              <Icon24 src={`${process.env.PUBLIC_URL}/images/product_medical2.png`} alt={t("translation:admin.request.list_field.policy_no")} />
              <FormTitleBlue title={t("translation:admin.request.list_field.policy_no")}>{data?.user?.IDPLNO ?? "-"}</FormTitleBlue>
            </Flex>

            <Flex>
              <Icon24 src={`${process.env.PUBLIC_URL}/images/document-shield.png`} alt={t("translation:admin.request.list_field.insured_no")} />
              <FormTitleBlue title={t("translation:admin.request.list_field.insured_no")}>{data?.user?.IDINSN ?? "-"}</FormTitleBlue>
            </Flex>

            <Flex>
              <Icon24 src={`${process.env.PUBLIC_URL}/images/document-shield.png`} alt={t("translation:admin.request.list_field.dependent_code")} />
              <FormTitleBlue title={t("translation:admin.request.list_field.dependent_code")}>{data?.user?.DEPENDCODE || "-"}</FormTitleBlue>
            </Flex>

            <Flex>
              <Icon24 src={`${process.env.PUBLIC_URL}/images/icon_email.png`} alt={t("translation:admin.request.list_field.email")} />
              <FormTitleBlue title={t("translation:admin.request.list_field.email")}>{data?.user?.email ?? "-"}</FormTitleBlue>
            </Flex>

            <Flex>
              <Icon24 src={`${process.env.PUBLIC_URL}/images/mobile.png`} alt={t("translation:admin.request.list_field.tel")} />
              <FormTitleBlue title={t("translation:admin.request.list_field.tel")}>{data?.form?.userTel ?? "-"}</FormTitleBlue>
            </Flex>

            <Flex>
              <Icon24 src={`${process.env.PUBLIC_URL}/images/calendar.png`} alt={t("translation:admin.request.list_field.submitted_date")} />
              <FormTitleBlue title={t("translation:admin.request.list_field.submitted_date")}>{data?.form?.submitdt?.substr(0, 10).replaceAll("-", "/") ?? "-"}</FormTitleBlue>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      <FormSelect
        options={statusOptionList()}
        value={intstatus}
        style={{ minWidth: 250 }}
        optionListHeight={500}
        disabled={disabledStable}
        handleSelect={(value) => {
          if (value.value === intstatus.value) {
            return;
          }
          setChangeState(true)

          // New Requests
          if (value.value === "NEW") {
            updateStatus(aid, value).then(() => {
              loadAdmGetPreAuthForm(aid);
            });
            return;
          }

          // Pending Supple
          if (value.value === "SUPPLE") {
            openContentSUPPLEModal(aid, value);
            return;
          }

          // Pending Review
          if (value.value === "REVIEW") {
            updateStatus(aid, value).then(() => {
              loadAdmGetPreAuthForm(aid);
            });
            return;
          }

          // Approved (LOG) & Change to LOG
          if (value.value === "APPROVELOG" || value.value === "CHGTOLOG") {
            openContentApprove1Modal(aid, value);
            return;
          }

          // Approved (PCA)
          if (value.value === "APPROVEPCA") {
            if (data?.form?.flowType === "STP") {
              // ContentApprove1
              setContentApprove1_TreatmentType(contentApprove1_TreatmentType_List.find(item => item.value === data?.claim?.treatmentType));
              setContentApprove1_ClassificationOfSurgery(contentApprove1_ClassificationOfSurgery_List.find(item => item.value === data?.claim?.classificationSurgery));
              setContentApprove1_ICD(data?.claim?.ICDCode || "");
              setContentApprove1_ICD_code(data?.claim?.ICDCodeList?.split(",") || []);
              setContentApprove1_Remarks(data?.claim?.treatmentRemarkOption?.split(",") || []);
              setContentApprove1_RemarksText(data?.claim?.treatmentRemark || "");
              setContentApprove1_savingAmount(data?.claim?.saveAmt || "");

              // ContentApprove2
              setContentApprove2_Operation(contentApprove2_Operation_List.find(item => item.value === data?.claim?.operationClassified));
              setContentApprove2_Accommodation(contentApprove2_Accommodation_List.find(item => item.value === data?.claim?.lvOfAccommodation));
              setContentApprove2_BenefitType(contentApprove2_BenefitType_List.find(item => item.value === data?.claim?.benefitType));
              setContentApprove2_lumpSumBenefitAmount(data?.claim?.lumpSumAmt || "");

              // ContentBasicHospitalAndSurgicalBenefits
              setContentBasicHospitalAndSurgicalBenefits_surgeon_fee(data?.claim?.surgeonFee);
              setContentBasicHospitalAndSurgicalBenefits_surgeon_fee_remark(data?.claim?.surgeonFeeRemark || "");
              setContentBasicHospitalAndSurgicalBenefits_anaesthetist_fee(data?.claim?.anaesthetistFee);
              setContentBasicHospitalAndSurgicalBenefits_anaesthetist_fee_remark(data?.claim?.anaesthetistFeeRemark || "");
              setContentBasicHospitalAndSurgicalBenefits_operating_theatre(data?.claim?.operatingTheatreFee);
              setContentBasicHospitalAndSurgicalBenefits_operating_theatre_remark(data?.claim?.operatingTheatreFeeRemark || "");
              setContentBasicHospitalAndSurgicalBenefits_miscellaneous_hospital_charges(data?.claim?.miscellaneousHospitalCharge);
              setContentBasicHospitalAndSurgicalBenefits_miscellaneous_hospital_charges_remark(data?.claim?.miscellaneousHospitalChargeRemark || "");
              setContentBasicHospitalAndSurgicalBenefits_physician_hospital_visit(data?.claim?.physicianFee);
              setContentBasicHospitalAndSurgicalBenefits_physician_hospital_visit_remark(data?.claim?.physicianFeeRemark || "");
              setContentBasicHospitalAndSurgicalBenefits_cnofdays(data?.claim?.cnofdays);
              setContentBasicHospitalAndSurgicalBenefits_room_and_board(data?.claim?.roomFee);
              setContentBasicHospitalAndSurgicalBenefits_room_and_board_remark(data?.claim?.roomFeeRemark || "");

              // ContentSMMBenefit
              setContentSMMBenefit_fillInSMMDetail(data?.claim?.SMMDetail === "Y" ? true : false);
              setContentSMMBenefit_deductibleAmount(data?.claim?.deductAmt || "");
              setContentSMMBenefit_reimbursementPercentage(data?.claim?.reimbursementPercent || "");
              setContentSMMBenefit_overallLimitType(contentSMMBenefit_overallLimit_type_list.find(item => item.value === data?.claim?.contentSMMBenefit_overallLimit_type));
              setContentSMMBenefit_overallLimit(data?.claim?.overallLimit || "");
              setContentSMMBenefit_remarks(data?.claim?.SMMRemarkOption?.split(",") || []);
              setContentSMMBenefit_remarksText(data?.claim?.SMMRemark || "");


            }

            openContentApprove1Modal(aid, value);
            return;
          }

          // LOG > PCA
          if (value.value === "CHGTOPCA") {
            openContentApprove1Modal(aid, value);
            return;
          }

          // Declined
          if (value.value === "DECLINED") {
            openContentDeclineFirstModal(aid, value);
            return;
          }

          // Pending Chargeback
          if (value.value === "PENDCHARGE") {
            openContentClaimRequest(aid, value);
            return;
          }

          // Scheduled Chargeback
          if (value.value === "SCHCHARGE") {
            openContentScheduledChargeback(aid, value);
            return;
          }

          // Outstanding Chargeback
          if (value.value === "OUTCHARGE") {
            updateStatus(aid, value).then(() => {
              loadAdmGetPreAuthForm(aid);
            });
            return;
          }

          // Chargeback Settled
          if (value.value === "CHARGESETTLE") {
            updateStatus(aid, value).then(() => {
              loadAdmGetPreAuthForm(aid);
            });
            return;
          }

          // Claim Settled
          if (value.value === "CLAIMSETTLE") {
            updateStatus(aid, value).then(() => {
              loadAdmGetPreAuthForm(aid);
            });
            return;
          }

          // Claim Settled
          if (value.value === "CANCELLED") {
            updateStatus(aid, value).then(() => {
              loadAdmGetPreAuthForm(aid);
            });
            return;
          }
        }}
      />
    </Container>
  );
}

const Container = styled(ShadowBox)`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 16px;
  column-gap: 32px;
`;

const Icon24 = styled.img`
  width: 24px;
  height: 24px;
`;

const FormTitleBlue = styled(FormTitle)`
  color: var(--aia-bx-dark-blue);
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;

const HDivider = styled.div`
  background-color: var(--aia-bx-gray-4);
  width: 100%;
  height: 1px;
`;

export default ApplicationInfo;